// extracted by mini-css-extract-plugin
export default {"payAttention":"PayAttention_payAttention__V3V6H","info":"PayAttention_info__dOzIe","title":"PayAttention_title__IKwYK","text":"PayAttention_text__-ejC0"};